import React from "react";
import styled from "styled-components";
import {
  PlusOutlined,
  MinusOutlined,
  RightOutlined,
  DownOutlined,
} from "@ant-design/icons";
import useMobileDetector from "../../../utils/useMobileDetector";

const CustomIconArea = styled.div`
  margin-right: 10px;
`;

const CustomIcon = ({ isActive }) => {
  const { isMobile } = useMobileDetector();

  if (!isMobile) {
    return (
      <CustomIconArea>
        {!isActive ? <PlusOutlined /> : <MinusOutlined />}
      </CustomIconArea>
    );
  }

  return (
    <CustomIconArea>
      <RightOutlined />
    </CustomIconArea>
  );
};

export default CustomIcon;
